import React from 'react';
import MainBody from './mainbody/MainBody';
import styles from '../index.css';

export default function App() {
  return (
    <div className={styles.app}>
      <MainBody />
    </div>
  );
}
